import './CanvasPopoutWindow.css';

import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import PopoutToggleIcon from '../PopoutToggleIcon/PopoutToggleIcon';
import LockItemsToggle from '../LockItemsToggle/LockItemsToggle';
import { useTranslate } from '../../../../../hooks/context/useTranslate';

interface CanvasPopoutWindowProps {
  popoutWindow: Window;
  onClose: () => void;
  children: ReactNode;
}

// Canvas popped out into the separate browser window: the children portal
// into the window document while the editor keeps a placeholder with a
// return button in place of the workspace.
const CanvasPopoutWindow: FC<CanvasPopoutWindowProps> = ({
  popoutWindow,
  onClose,
  children,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="layout-editor-workspace canvas-popout-placeholder">
        <p>{t('layoutEditor.popoutPlaceholder')}</p>
        <div className="layout-editor-workspace-actions">
          <LockItemsToggle />
          <button
            type="button"
            className="layout-editor-popout-button"
            title={t('layoutEditor.popoutClose')}
            onClick={onClose}
          >
            <PopoutToggleIcon variant="contract" />
          </button>
        </div>
      </div>
      {createPortal(
        <div className="canvas-popout-root">{children}</div>,
        popoutWindow.document.body
      )}
    </>
  );
};

export default CanvasPopoutWindow;
